export const FALLBACK_INQUIRY_TYPE = [
  { value: "general", label: "General" },
  { value: "payment_recovery", label: "Payment Recovery" },
  { value: "task", label: "Task" },
  { value: "case_management", label: "Case Management" },
  { value: "gst", label: "GST" },
];

export const FALLBACK_INQUIRY_SOURCE = [
  { value: "Website", label: "Website" },
  { value: "Call", label: "Call" },
  { value: "WhatsApp", label: "WhatsApp" },
  { value: "Email", label: "Email" },
  { value: "Walk-in", label: "Walk-in" },
  { value: "Referral", label: "Referral" },
  { value: "Facebook", label: "Facebook" },
  { value: "Existing Client", label: "Existing Client" },
  { value: "Other", label: "Other" },
];

export const FALLBACK_INQUIRY_PRIORITY = [
  { value: "Low", label: "Low" },
  { value: "Medium", label: "Medium" },
  { value: "High", label: "High" },
  { value: "Urgent", label: "Urgent" },
];

export const FALLBACK_INQUIRY_SERVICE = [
  { value: "Income Tax Filing", label: "Income Tax Filing" },
  { value: "GST Registration & Compliance", label: "GST Registration & Compliance" },
  { value: "Audit & Assurance", label: "Audit & Assurance" },
  { value: "ROC Filings", label: "ROC Filings" },
  { value: "Bookkeeping", label: "Bookkeeping" },
  { value: "Tax Planning", label: "Tax Planning" },
  { value: "Startup Advisory", label: "Startup Advisory" },
  { value: "Other", label: "Other" },
];

export const FALLBACK_FOLLOWUP_TYPE = [
  { value: "Call", label: "Call" },
  { value: "Email", label: "Email" },
  { value: "Meeting", label: "Meeting" },
  { value: "WhatsApp", label: "WhatsApp" },
  { value: "Other", label: "Other" },
];

export const FALLBACK_FOLLOWUP_OUTCOME = [
  { value: "In Progress", label: "In Progress" },
  { value: "Completed", label: "Completed" },
  { value: "Interested", label: "Interested" },
  { value: "Not Interested", label: "Not Interested" },
  { value: "No Response", label: "No Response" },
  { value: "Callback Later", label: "Callback Later" },
  { value: "Converted", label: "Converted" },
];

export const FALLBACK_FOLLOWUP_PRIORITY = [
  { value: "High", label: "High" },
  { value: "Medium", label: "Medium" },
  { value: "Low", label: "Low" },
];

export const FALLBACK_FOLLOWUP_STATUS = [
  { value: "Pending", label: "Pending" },
  { value: "In Progress", label: "In Progress" },
  { value: "Completed", label: "Completed" },
];

export const FALLBACK_TASK_PRIORITY = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
];

export const FALLBACK_TASK_STATUS = [
  { value: "pending", label: "Pending" },
  { value: "inProgress", label: "In Progress" },
  { value: "completed", label: "Completed" },
];

export const FALLBACK_COMMUNICATION_TYPE = [
  { value: "Email", label: "Email" },
  { value: "Call", label: "Call" },
  { value: "Message", label: "Message" },
  { value: "WhatsApp", label: "WhatsApp" },
];

export const FALLBACK_COMMUNICATION_CHANNEL = [
  { value: "Email", label: "Email" },
  { value: "Phone", label: "Phone" },
  { value: "WhatsApp", label: "WhatsApp" },
  { value: "SMS", label: "SMS" },
];

export const FALLBACK_DOCUMENT_TYPE = [
  { value: "personal", label: "Personal" },
  { value: "business", label: "Business" },
];

export const FALLBACK_DOCUMENT_CATEGORY = [
  { value: "KYC", label: "KYC" },
  { value: "GST", label: "GST" },
  { value: "Notice", label: "Notice" },
  { value: "Order", label: "Order" },
  { value: "Agreement", label: "Agreement" },
  { value: "Other", label: "Other" },
];

export const FALLBACK_GST_STATUS = [
  { value: "New", label: "New" },
  { value: "Pending", label: "Pending" },
  { value: "Completed", label: "Completed" },
  { value: "Closed", label: "Closed" },
];

export const FALLBACK_GST_STAGE = [
  { value: "Notice", label: "Notice" },
  { value: "Reply", label: "Reply" },
  { value: "Hearing", label: "Hearing" },
  { value: "Order", label: "Order" },
  { value: "Appeal", label: "Appeal" },
];

export const FALLBACK_GST_HEARING = [
  { value: "Scheduled", label: "Scheduled" },
  { value: "Completed", label: "Completed" },
  { value: "Adjourned", label: "Adjourned" },
  { value: "Cancelled", label: "Cancelled" },
];

export const FALLBACK_GST_DEMAND = [
  { value: "Confirmed", label: "Confirmed" },
  { value: "Dropped", label: "Dropped" },
  { value: "Partial", label: "Partial" },
  { value: "Paid", label: "Paid" },
];

export const FALLBACK_EMPLOYEE_DEPARTMENT = [
  { value: "Accounts", label: "Accounts" },
  { value: "Audit", label: "Audit" },
  { value: "GST", label: "GST" },
  { value: "Income Tax", label: "Income Tax" },
  { value: "ROC", label: "ROC" },
  { value: "Admin", label: "Admin" },
];

export const FALLBACK_COMMUNICATION_RELATED = [
  { value: "customer", label: "Customer" },
  { value: "employee", label: "Employee" },
];

export const FALLBACK_PAYMENT_STATUS = [
  { value: "New", label: "New" },
  { value: "In Progress", label: "In Progress" },
  { value: "Awarded", label: "Awarded" },
  { value: "Recovered", label: "Recovered" },
  { value: "Withdrawn", label: "Withdrawn" },
  { value: "Closed", label: "Closed" },
];

export const FALLBACK_PAYMENT_STAGE = [
  { value: "Legal Notice", label: "Legal Notice" },
  { value: "Rejoinder", label: "Rejoinder" },
  { value: "GST Complaint", label: "GST Complaint" },
  { value: "ODR", label: "ODR" },
  { value: "Hearing", label: "Hearing" },
  { value: "Arbitration", label: "Arbitration" },
  { value: "Order", label: "Order" },
  { value: "Withdrawal", label: "Withdrawal" },
];

export const FALLBACK_INQUIRY_STATUS = [
  { value: "new", label: "New" },
  { value: "assigned", label: "Assigned" },
  { value: "contacted", label: "Contacted" },
  { value: "follow-up", label: "Follow-up" },
  { value: "qualified", label: "Qualified" },
  { value: "converted", label: "Converted" },
  { value: "lost", label: "Lost" },
];

export const MASTER_GROUP_LABELS = [
  { key: "inquiry_type", label: "Inquiry type" },
  { key: "inquiry_status", label: "Inquiry status" },
  { key: "inquiry_source", label: "Inquiry source" },
  { key: "inquiry_priority", label: "Inquiry priority" },
  { key: "inquiry_service", label: "Inquiry service" },
  { key: "followup_type", label: "Follow-up type" },
  { key: "followup_outcome", label: "Follow-up outcome" },
  { key: "followup_priority", label: "Follow-up priority" },
  { key: "followup_status", label: "Follow-up status" },
  { key: "task_priority", label: "Task priority" },
  { key: "task_status", label: "Task status" },
  { key: "task_type", label: "Task work type" },
  { key: "communication_type", label: "Communication type" },
  { key: "communication_channel", label: "Communication channel" },
  { key: "document_type", label: "Document type" },
  { key: "document_category", label: "Document category" },
  { key: "gst_case_status", label: "GST case status" },
  { key: "gst_case_stage", label: "GST case stage" },
  { key: "gst_hearing_status", label: "GST hearing status" },
  { key: "gst_demand_status", label: "GST demand status" },
  { key: "employee_department", label: "Employee department" },
  { key: "communication_related_to", label: "Communication related to" },
  { key: "payment_recovery_status", label: "Payment recovery status" },
  { key: "payment_recovery_stage", label: "Payment recovery stage" },
];
